export default "__VITE_ASSET__BU9Vk219__"